import { ActionTypes } from "../constants/action_types";

const initialState = null;
export const tenantIntegrationViewReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.TENANT_INTEGRATION_VIEW:
            return payload; //sidebarShow 
        default:
            return state;
    }
}
